import NormalButton from '@/components/items/Buttons/NormalButton'
import { commonUtil } from '@/util'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    NormalButton
  },
  props: {
    submitButtonName: { default: 'common.common_confirmation' },
    productListData: {
      type: Object,
      require: true,
      default: () => ({})
    },
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    isRegister: { default: false },
    isOrder: { default: false },
    isDaialogSize: { default: true }
  },
  data: () => ({}),
  methods: {
    submit() {
      this.$emit('submit')
    },

    getTaxFreeAmount(newVal) {
      // 発注の場合は登録時に選択された通貨が日本円の場合、各消費税小計項目に設定
      // 販売の場合は輸出主体による
      if (this.isOrder && this.totalList.currencyId != 1) {
        return newVal.reduce((result, current) => {
          return result + current.amount
        }, 0)
      } else {
        return newVal
          .filter((ele) => ele.exportSubjectFlg)
          .reduce((result, current) => {
            return result + current.amount
          }, 0)
      }
    },
    getTaxRateNum(id) {
      if (id === 8 || id === '8') {
        return 1
      }
      return 2
    },
    filterTaxAmount(newVal, taxValue) {
      if (this.isOrder && this.totalList.currencyId == 1) {
        return newVal
          .filter((ele) => ele.taxId === this.getTaxRateNum(taxValue))
          .reduce((result, current) => {
            return result + current.amount
          }, 0)
      } else if (!this.isOrder) {
        return newVal
          .filter(
            (ele) =>
              !ele.exportSubjectFlg &&
              ele.taxId === this.getTaxRateNum(taxValue)
          )
          .reduce((result, current) => {
            return result + current.amount
          }, 0)
      } else {
        return 0
      }
    },
    getTax(num, taxPercentage) {
      return this.formatPrice((num * taxPercentage) / 100)
    },
    setData() {
      if (!this.isRegister) return

      // 無効フラグがtrueの商品を除外する
      const enabledProductList = this.productListData.data.filter(
        (item) => !item.disabledFlg
      )

      const taxFree = this.getTaxFreeAmount(enabledProductList)
      this.totalList.taxFree = taxFree

      const taxType = [10, 8]
      taxType.reduce((result, current) => {
        const amount = this.filterTaxAmount(enabledProductList, current)

        let taxOnly

        taxOnly = this.productListData.isHistory
          ? this.totalList['tax' + current].tax
          : this.getTax(amount, current)

        this.totalList['tax' + current] = {
          totalAmount: amount,
          tax: taxOnly
        }
        return result + Number(amount) + Number(taxOnly)
      }, 0)
    },

    getTotalAmount() {
      return BigNumber(
        Number(this.totalList.taxFree) +
          Number(this.totalList.tax10.totalAmount) +
          Number(this.totalList.tax10.tax) +
          Number(this.totalList.tax8.totalAmount) +
          Number(this.totalList.tax8.tax) +
          Number(this.totalList.shipping)
      )
        .minus(Number(this.totalList.discount))
        .toNumber()
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    totalList: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    isTotalAmountSize() {
      return {
        totalAmountDialogSize: this.isDaialogSize,
        totalAmountSize: !this.isDaialogSize
      }
    }
  },
  watch: {
    productListData: {
      deep: true,
      handler(newVal, oldVal) {
        this.setData()
      }
    }
    // 'totalList.discount': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.shipping': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.tax10.tax': function (val) {
    //   this.setData(true)
    // },
    // 'totalList.tax8.tax': function (val) {
    //   this.setData(true)
    // }
  }
}
